import { SelectedBatches } from '../../BatchesList/typings';
import {
    CanvasApiBaseResponse,
    CreateHtml5Response,
    Html5CreativesApiResponse,
    UploadHtml5Response
} from '../../common/requestsTypings';
import { Order, SharedData } from '../../common/typings';
import { CreativesApiMethodExecutor } from '../CreativesApiMethodExecutor/CreativesApiMethodExecutor';

type GetParams = {
    offset: number;
    order: Order;
    sizes: string[];
    filterText: string;
    archived: boolean;
};

const uploadHeaders = {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
};

const GET_PATH = 'html5/batches';
const UPDATE_PATH = 'html5/batch';
const UPLOAD_PATH = 'html5/source';
const DIRECT_PATH = 'html5/direct/creatives';
const API_PATH = '/canvas-api';

export class Html5ApiMethodExecutor extends CreativesApiMethodExecutor {
    constructor() {
        super(UPDATE_PATH, API_PATH);
    }

    async getCreatives(getParams: GetParams, sharedData: SharedData): Promise<Html5CreativesApiResponse> {
        const { offset, order, filterText, archived } = getParams;
        const queryParams = [`offset=${offset}`, 'limit=50', `sort_order=${order}`];
        if (filterText) {
            queryParams.push(`name=${filterText}`);
        }
        if (archived) {
            queryParams.push('archive=true');
        }

        return this.createRequest<Html5CreativesApiResponse>(GET_PATH, { method: 'GET' }, sharedData, queryParams);
    }

    async submit(batches: SelectedBatches, sharedData: SharedData): Promise<CanvasApiBaseResponse> {
        const html5Batches = batches.map(item => {
            return {
                id: item.id,
                creative_ids: item.creativeIds
            };
        });

        return await this.createRequest<CanvasApiBaseResponse>(
            DIRECT_PATH,
            {
                method: 'POST',
                body: JSON.stringify({ batches: html5Batches })
            },
            sharedData
        );
    }

    async upload(file: File, sharedData: SharedData): Promise<UploadHtml5Response> {
        const formData = new FormData();
        formData.append('attachment', file);
        const params = {
            method: 'POST',
            body: formData,
            headers: uploadHeaders
        };

        return this.createRequest<UploadHtml5Response>(UPLOAD_PATH, params, sharedData);
    }

    async create(name: string, ids: string[], sharedData: SharedData): Promise<CreateHtml5Response> {
        const params = {
            method: 'POST',
            body: JSON.stringify({
                name,
                sources: ids.map(id => ({ id }))
            })
        };

        return this.createRequest<CreateHtml5Response>(UPDATE_PATH, params, sharedData);
    }
}
